/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import config from '../config/getSupplyStepper.config.json';

// import axios from "axios";
// import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
// import { UPDATE_MY_ORGANIZATION } from "../graphql";
// import { VApplication } from "../../../application";

// const getGraphQLModule = () => {
//   const app = VApplication.getInstance();
//   return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
// };

export interface IGetSupplyStepperMethods extends IPluginMethodMap {
  getGetSupplyStepper(args: any): Promise<any>;
}

export interface GetSupplyStepperProps {
  [key: string]: any;
}

export class GetSupplyStepperService implements IAgentPlugin {
  readonly methods: IGetSupplyStepperMethods;

  constructor() {
    this.methods = {
      getGetSupplyStepper: this.getGetSupplyStepper.bind(this),
    };
  }

  async getGetSupplyStepper(args: GetSupplyStepperProps) {
    // const graphqlModule = getGraphQLModule();
    // const client = graphqlModule.getClient("graphql-gateway");

    // try {
    //   if (client) {
    //     const res = await client.mutate({
    //       mutation: UPDATE_MY_ORGANIZATION,
    //       variables: {
    //         input: {
    //           ...args,
    //         },
    //       },
    //       fetchPolicy: "no-cache",
    //     });
    //     if (res?.data) {
    //       return {
    //         data: res?.data,
    //       };
    //     }
    //   }
    // } catch (err: any) {
    //   throw err;
    // }
    return { ...config };
  }
}
